export const sliderParams = {
  desktopL: { cols: 7, allGames: 63, rows: 3 },
  desktop: { cols: 7, allGames: 63, rows: 3 },
  tablet: { cols: 4, allGames: 32, rows: 2 },
  mobile: { cols: 3, allGames: 30, rows: 2 },
  mobileS: { cols: 2, allGames: 32, slidesPerView: 1.1, rows: 2 },
};

export const oneRowSliderParams = {
  desktopL: { cols: 7, allGames: 21, rows: 1 },
  desktop: { cols: 7, allGames: 21, rows: 1 },
  tablet: { cols: 4, allGames: 16, rows: 1 },
  mobile: { cols: 3, allGames: 12, rows: 1 },
  mobileS: { cols: 2, allGames: 12, slidesPerView: 1.1, rows: 1 },
};

export const oneRowSliderLiveCasinoParams = {
  desktopL: { cols: 7, allGames: 21, rows: 1 },
  desktop: { cols: 7, allGames: 21, rows: 1 },
  tablet: { cols: 4, allGames: 16, rows: 1 },
  mobile: { cols: 3, allGames: 12, rows: 1 },
  mobileS: { cols: 2, allGames: 12, slidesPerView: 1.1, rows: 1 },
};

export const twoRowsSliderParams = {
  desktopL: { cols: 7, allGames: 42, rows: 2 },
  desktop: { cols: 7, allGames: 42, rows: 2 },
  tablet: { cols: 4, allGames: 32, rows: 2 },
  mobile: { cols: 3, allGames: 32, rows: 2 },
  mobileS: { cols: 2, allGames: 32, slidesPerView: 1.1, rows: 2 },
};

export const sliderTopCategoryParams = {
  desktopL: { cols: 7, allGames: 63, rows: 3 },
  desktop: { cols: 7, allGames: 63, rows: 3 },
  tablet: { cols: 4, allGames: 36, rows: 3 },
  mobile: { cols: 3, allGames: 36, rows: 3 },
  mobileS: { cols: 2, allGames: 36, slidesPerView: 1.1, rows: 3 },
};

export const HITS_SLIDER_PARAMS = {
  desktopL: { cols: 7, allGames: 21, rows: 1 },
  desktop: { cols: 7, allGames: 21, rows: 1 },
  tablet: { cols: 4, allGames: 32, rows: 2 },
  mobile: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
  mobileS: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
};

export const WAGERING_SLIDER_PARAMS = {
  desktopL: { cols: 7, allGames: 21, rows: 1 },
  desktop: { cols: 7, allGames: 21, rows: 1 },
  tablet: { cols: 4, allGames: 16, rows: 1 },
  mobile: { cols: 3, allGames: 12, rows: 1 },
  mobileS: { cols: 2, allGames: 12, slidesPerView: 1.1, rows: 1 },
};

export const TOP_VIP_SLIDER_PARAMS = {
  desktopL: { cols: 7, allGames: 21, rows: 1 },
  desktop: { cols: 7, allGames: 21, rows: 1 },
  tablet: { cols: 4, allGames: 16, rows: 1 },
  mobile: { cols: 3, allGames: 12, rows: 1 },
  mobileS: { cols: 2, allGames: 12, slidesPerView: 1.1, rows: 1 },
};

export const JACKPOT_SLIDER_PARAMS = {
  desktopL: { cols: 7, allGames: 21, rows: 1 },
  desktop: { cols: 7, allGames: 21, rows: 1 },
  tablet: { cols: 4, allGames: 16, rows: 1 },
  mobile: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
  mobileS: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
};

export const INSTANT_WINS_SLIDER_PARAMS = {
  desktopL: { cols: 7, allGames: 21, rows: 1 },
  desktop: { cols: 7, allGames: 21, rows: 1 },
  tablet: { cols: 4, allGames: 16, rows: 1 },
  mobile: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
  mobileS: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
};

export const BONUS_BUY_SLIDER_PARAMS = {
  desktopL: { cols: 7, allGames: 21, rows: 1 },
  desktop: { cols: 7, allGames: 21, rows: 1 },
  tablet: { cols: 4, allGames: 16, rows: 1 },
  mobile: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
  mobileS: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
};

export const WAGERING_SUB_CATEGORY_SLIDER_PARAMS = {
  desktopL: { cols: 7, allGames: 42, rows: 2 },
  desktop: { cols: 7, allGames: 42, rows: 2 },
  tablet: { cols: 4, allGames: 24, rows: 2 },
  mobile: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
  mobileS: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
};

export const PENNY_BETS_SUB_CATEGORY_SLIDER_PARAMS = {
  desktopL: { cols: 7, allGames: 21, rows: 1 },
  desktop: { cols: 7, allGames: 21, rows: 1 },
  tablet: { cols: 4, allGames: 24, rows: 2 },
  mobile: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
  mobileS: { cols: 2, allGames: 24, slidesPerView: 1.1, rows: 2 },
};
